module.exports = __webpack_public_path__ + "img/elementa-linguae-daco-romanae-sive-valachicae-viena-1780.33830db6.jpg";